module.exports = __webpack_public_path__ + "img/nav-thumbnail-slidey-blocks.72f1b1cb.png";